// extracted by mini-css-extract-plugin
export default {"breadcrumbsBlock":"breadcrumbs_breadcrumbsBlock__nk+SE"};